/**
 * Messages de la page d'accueil
 */

module.exports = {

    // Demande de congés reçus par un manager
    requestedHolidays: {
        title: 'Paid holidays',
        button: {
            label: 'Access to requests'
        }
    },

    // Congés restant pour un agent
    remainingHolidays: {
        internal: {
            title: 'Paid holidays',
            counter: 'No remaining holidays | { count } remaining holidays | { count } remaining holidays',
            requestButton: {
                label: 'Request holidays'
            },
            requestModal: {
                create: {
                    title: 'Make a holiday request'
                },
                edit: {
                    title: 'Edit a holiday request'
                },
                introduction: 'If you wish to take more than one non-consecutive vacation, please submit one request per period.'
            }
        },
        external: {
            title: 'Absences',
            requestButton: {
                label: 'Report an absence'
            },
            requestModal: {
                create: {
                    title: 'Make an absence request'
                },
                edit: {
                    title: 'Editing an absence request'
                },
                introduction: 'If you wish to take several non-consecutive absences, please submit one request per period.'
            }
        }
    },

    // Gestion du calendrier d'un manager
    manager: {
        agents: {
            loadingError: 'An error occurred during agent loading.',
            list: {
                title: 'Agents',
                filter: {
                    title: 'Filtering agents',
                    button: {
                        label: 'Filter',
                        altLabel: 'Filter agents'
                    }
                },
                addAgent: {
                    button: {
                        label: 'Add an agent'
                    }
                },
                consultRequestedHolidays: {
                    button: {
                        label: 'Requests',
                        altLabel: 'View vacation requests.'
                    }
                }
            }
        }
    },

    // Gestion de la page d'accueil du client
    customer: {
        tasks: {
            title: 'View my publication schedule',
            altTitle: 'Consult your publication schedule.',
            description: 'Visualize, edit and validate!'
        },
        publicationSuggestions: {
            title: 'Find publication ideas',
            altTitle: 'Create a new task.',
            description: 'Create without ideas!'
        },
        creditsSubscription: {
            title: 'My subscription and credits',
            altTitle: 'Manage your subscription and buy credits.',
            description: 'Subscribe or modify!'
        },
        horseChestnutEvent: {
            title: 'Consult the next evergreens',
            altTitle: 'View the schedule of upcoming events.',
            description: 'Create based on the evergreen!'
        }
    }
};
